import React, {Component} from 'react';
import './PasswordResetRequestComponent.less';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {ButtonLink, ButtonPrimary} from '@homeaway/react-buttons';
import {apiPost} from '../../util/api.client';
import {FormInput} from '@homeaway/react-form-components';
import {TrackingContext} from '@homeaway/react-event-tracking';
import LogInComponent from '../LogInComponent/LogInComponent';
import {getSiteHeader} from '../../util/siteHeaderUtils';

class PasswordResetRequestComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            errorMsg: '',
            loading: false,
        };
    }

    handleSubmit = (event) => {
        event.stopPropagation();
        event.preventDefault();
    }

    buttonClicked = () => {
        this.props.enableLoading();
        setTimeout(() => {
            this.resetPassword();
        }, 800);
    };

    resetPassword = () => {
        const url = '/auth/aam/v3/password/reset';
        const body = {
            'emailAddress': this.state.emailAddress,
            serviceUrl: this.props.service
        };

        apiPost(url, body, getSiteHeader(this.props.site)).then((response) => {
            if (response.status === 204) {
                this.props.updatePage('passwordreset');
                this.context.trigger('generic.event', {
                    eventaction: 'passwordreset.email.sent',
                    eventcategory: 'passwordreset',
                    eventlabel: 'ums'
                });
            } else {
                this.props.handleError(this.props.lingua.read('error.generic'), '');
                this.context.trigger('generic.event', {
                    eventaction: 'passwordreset.email.sent.error',
                    eventcategory: 'passwordreset',
                    eventvalue: `${response.status}`,
                    eventlabel: 'ums'
                });
            }
            this.props.disableLoading();
        });
    }

    returnLogin = () => {
        this.props.updatePage('LOGIN_UMS');
    }

    render = () => {
        let {lingua, isWaiting, isLegacy} = this.props;
        let emailInputClass = isLegacy ? 'email-address' : '';
        return (
            <div className="ResetRequest text-center">
                <p className="Subtitle">{lingua.read('lex.legacy.password.reset')}</p>
                <form onSubmit={this.handleSubmit} noValidate>
                    <div className="EmailField">
                        <FormInput
                            id="lex-emailAddress"
                            name = "emailAddress"
                            className={emailInputClass}
                            label = {lingua.read('form.placeholder.emailAddress')}
                            value = {this.state.emailAddress}
                            onChange = {this.handleChange}
                            type= "email"
                            autoComplete = "on"
                            errorMsg={this.state.errorEmailMsg}
                            disabled={isLegacy}
                            autoFocus={!isLegacy}
                        />
                    </div>
                    <div className="Save_button text-center">
                        <ButtonPrimary type="submit" label={lingua.read('button.send')} onClick={this.buttonClicked} className="btn-lg">
                            <LoadingOverlay loading={isWaiting} />
                        </ButtonPrimary>
                    </div>
                </form>
                <ButtonLink className="Link text-center" label={lingua.read('lex.password.reset.button')} onClick={this.returnLogin}/>
            </div>
        );
    };
}

LogInComponent.contextType = TrackingContext;
export default PasswordResetRequestComponent;
